import { useSyncExternalStore } from 'react';
import { getIsOnline, subscribe } from '../services/connectivityService';

const useOnlineStatus = () => {
  return useSyncExternalStore(subscribe, getIsOnline);
};

export default useOnlineStatus;
